// eslint-disable-next-line no-restricted-imports -- TextField is needed for multiline input
import { TextField } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { SurveyStepLayout } from "../components/SurveyStepLayout";
import { type ScreeningSurveyFormData } from "../lib/screeningSurveySchema";

interface WhyHealthcareStepProps {
  onContinue: () => void;
  onBack: () => void;
  currentStep: number;
  totalSteps: number;
  isSubmitting?: boolean;
}

const MIN_LENGTH = 10;

export function WhyHealthcareStep(props: WhyHealthcareStepProps) {
  const { onContinue, onBack, currentStep, totalSteps, isSubmitting = false } = props;
  const { watch, setValue } = useFormContext<ScreeningSurveyFormData>();
  const value = watch("whyHealthcare") ?? "";
  const trimmedLength = value.trim().length;
  const meetsMinimum = trimmedLength >= MIN_LENGTH;

  return (
    <SurveyStepLayout
      currentStep={currentStep}
      totalSteps={totalSteps}
      title="Why did you get into healthcare?"
      subtitle="This will be shown on your public profile."
      continueDisabled={trimmedLength < MIN_LENGTH || isSubmitting}
      continueLabel="Complete"
      onBack={onBack}
      onContinue={onContinue}
    >
      <TextField
        fullWidth
        multiline
        required
        minRows={4}
        maxRows={8}
        placeholder="Share your story..."
        value={value}
        helperText={
          meetsMinimum
            ? `✓ ${trimmedLength} characters`
            : `Minimum ${MIN_LENGTH} characters (${trimmedLength}/${MIN_LENGTH})`
        }
        FormHelperTextProps={{
          sx: (theme) => ({
            textAlign: "right",
            marginRight: 0,
            color: meetsMinimum ? theme.palette.success.main : theme.palette.error.main,
          }),
        }}
        onChange={(event) => {
          setValue("whyHealthcare", event.target.value);
        }}
      />
    </SurveyStepLayout>
  );
}
